"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const CustomWarningIcon = (_a) => {
    var { viewBox = '0 0 24 24' } = _a, props = __rest(_a, ["viewBox"]);
    return ((0, jsx_runtime_1.jsx)(core_1.SvgIcon, Object.assign({}, props, { children: (0, jsx_runtime_1.jsxs)("svg", Object.assign({ viewBox: viewBox }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z" }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "16", r: "1" }), (0, jsx_runtime_1.jsx)("path", { d: "M11 7h2v7h-2z" })] })) })));
};
exports.default = CustomWarningIcon;
//# sourceMappingURL=CustomWarningIcon.js.map